// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 독립 연결 창 제목줄의 조회 대상(연결 · 세션) 표시·선택기.
   모양은 여기 한 곳이다 — 창마다 접두어를 바꿔 또 칠하지 말 것. */

.montgt {
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
}

.montgt-icon { color: #9ca3af; flex-shrink: 0; }
.montgt-sep { color: #d1d5db; }

.montgt-conn {
  max-width: 190px;
  padding: 3px 6px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  color: #374151;
  font-size: 11.5px;
  transition: border-color 150ms ease, background 150ms ease;
}
.montgt-conn:hover { border-color: #9ca3af; }

.montgt-session {
  display: flex;
  align-items: center;
  gap: 4px;
  /* 폭을 못 박는다 — 세션 이름·SID 는 길이가 제각각이라, 내용에 따라 늘어나면
     세션을 바꿀 때마다 제목줄의 닫기 버튼까지 좌우로 밀린다.
     210px 은 실측으로 정했다 — \`resource-analysis · sid 1353\`(가장 긴 창 이름)이
     잘리지 않는 폭이다. 그보다 길면 말줄임하고 title 로 전체를 보여 준다. */
  width: 210px;
  padding: 3px 7px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  color: #374151;
  cursor: pointer;
  font-size: 11.5px;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease;
}
.montgt-session:hover { border-color: #3b82f6; }
.montgt-session-warn { border-color: #fbbf24; color: #92400e; }

.montgt-session-label {
  flex: 1 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.montgt-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 20;
  min-width: 260px;
  max-height: 320px;
  overflow: auto;
  padding: 4px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
  animation: montgt-fade-swap 150ms ease-out;
}
@keyframes montgt-fade-swap {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}

.montgt-group-title {
  padding: 5px 8px 3px;
  font-size: 10.5px;
  font-weight: 600;
  color: #9ca3af;
}

.montgt-option {
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  padding: 5px 8px;
  border: none;
  border-radius: 4px;
  background: none;
  color: #374151;
  font-size: 11.5px;
  text-align: left;
  cursor: pointer;
  transition: background 150ms ease;
}
.montgt-option:hover:not(:disabled) { background: #f3f4f6; }
/* 실행 중인 세션 — 눌러도 서버가 409 로 거절하므로 아예 막고, 왜 막혔는지 배지로 말한다 */
.montgt-option:disabled { opacity: 0.5; cursor: not-allowed; }

.montgt-opt-conn { color: #6b7280; flex-shrink: 0; }
.montgt-opt-name { flex: 1 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.montgt-opt-sid { color: #9ca3af; font-variant-numeric: tabular-nums; }
.montgt-opt-busy {
  padding: 0 6px;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  font-size: 10px;
  font-weight: 600;
}

.montgt-warn {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  padding: 6px 8px;
  margin-bottom: 3px;
  border-radius: 4px;
  background: #fffbeb;
  color: #92400e;
  font-size: 10.5px;
  line-height: 1.5;
}

.montgt-empty { padding: 10px 8px; color: #9ca3af; text-align: center; }

/* ===================== Dark mode ===================== */
/* color 를 함께 주지 않으면 밝은 모드 값이 남아 어두운 배경에 검은 글자가 된다 */
[data-theme="dark"] .montgt-sep { color: var(--color-border); }
[data-theme="dark"] .montgt-conn,
[data-theme="dark"] .montgt-session {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}
[data-theme="dark"] .montgt-conn:hover { border-color: var(--color-text-muted); }
[data-theme="dark"] .montgt-session:hover { border-color: #3b82f6; color: var(--color-text); }
[data-theme="dark"] .montgt-session-warn { border-color: #b45309; color: #fcd34d; }
[data-theme="dark"] .montgt-menu {
  background: var(--color-bg-tertiary);
  border-color: var(--color-border);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);
}
[data-theme="dark"] .montgt-group-title { color: var(--color-text-muted); }
[data-theme="dark"] .montgt-option { color: var(--color-text); }
[data-theme="dark"] .montgt-option:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }
[data-theme="dark"] .montgt-opt-conn { color: var(--color-text-secondary, #9ca3af); }
[data-theme="dark"] .montgt-opt-sid { color: var(--color-text-muted); }
[data-theme="dark"] .montgt-opt-busy { background: #78350f; color: #fcd34d; }
[data-theme="dark"] .montgt-warn { background: rgba(180, 83, 9, 0.18); color: #fcd34d; }
[data-theme="dark"] .montgt-empty { color: var(--color-text-muted); }

@media (prefers-reduced-motion: reduce) {
  .montgt-menu { animation: none; }
  .montgt-conn, .montgt-session, .montgt-option { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/OwnConnTarget.css"],"names":[],"mappings":"AAAA;0CAC0C;;AAE1C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,eAAe,cAAc,EAAE,cAAc,EAAE;AAC/C,cAAc,cAAc,EAAE;;AAE9B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0DAA0D;AAC5D;AACA,qBAAqB,qBAAqB,EAAE;;AAE5C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;;;kDAGgD;EAChD,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,4EAA4E;AAC9E;AACA,wBAAwB,qBAAqB,EAAE;AAC/C,uBAAuB,qBAAqB,EAAE,cAAc,EAAE;;AAE9D;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,0CAA0C;AAC5C;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA,sCAAsC,mBAAmB,EAAE;AAC3D,yDAAyD;AACzD,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D,mBAAmB,cAAc,EAAE,cAAc,EAAE;AACnD,mBAAmB,SAAO,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5F,kBAAkB,cAAc,EAAE,kCAAkC,EAAE;AACtE;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gBAAgB,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAEvE,0DAA0D;AAC1D,oDAAoD;AACpD,kCAAkC,0BAA0B,EAAE;AAC9D;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;AACA,yCAAyC,qCAAqC,EAAE;AAChF,4CAA4C,qBAAqB,EAAE,wBAAwB,EAAE;AAC7F,2CAA2C,qBAAqB,EAAE,cAAc,EAAE;AAClF;EACE,oCAAoC;EACpC,iCAAiC;EACjC,0CAA0C;AAC5C;AACA,0CAA0C,8BAA8B,EAAE;AAC1E,qCAAqC,wBAAwB,EAAE;AAC/D,0DAA0D,8BAA8B,EAAE,wBAAwB,EAAE;AACpH,uCAAuC,2CAA2C,EAAE;AACpF,sCAAsC,8BAA8B,EAAE;AACtE,uCAAuC,mBAAmB,EAAE,cAAc,EAAE;AAC5E,mCAAmC,kCAAkC,EAAE,cAAc,EAAE;AACvF,oCAAoC,8BAA8B,EAAE;;AAEpE;EACE,eAAe,eAAe,EAAE;EAChC,gDAAgD,gBAAgB,EAAE;AACpE","sourcesContent":["/* 독립 연결 창 제목줄의 조회 대상(연결 · 세션) 표시·선택기.\r\n   모양은 여기 한 곳이다 — 창마다 접두어를 바꿔 또 칠하지 말 것. */\r\n\r\n.montgt {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 11.5px;\r\n}\r\n\r\n.montgt-icon { color: #9ca3af; flex-shrink: 0; }\r\n.montgt-sep { color: #d1d5db; }\r\n\r\n.montgt-conn {\r\n  max-width: 190px;\r\n  padding: 3px 6px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  color: #374151;\r\n  font-size: 11.5px;\r\n  transition: border-color 150ms ease, background 150ms ease;\r\n}\r\n.montgt-conn:hover { border-color: #9ca3af; }\r\n\r\n.montgt-session {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  /* 폭을 못 박는다 — 세션 이름·SID 는 길이가 제각각이라, 내용에 따라 늘어나면\r\n     세션을 바꿀 때마다 제목줄의 닫기 버튼까지 좌우로 밀린다.\r\n     210px 은 실측으로 정했다 — `resource-analysis · sid 1353`(가장 긴 창 이름)이\r\n     잘리지 않는 폭이다. 그보다 길면 말줄임하고 title 로 전체를 보여 준다. */\r\n  width: 210px;\r\n  padding: 3px 7px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  font-size: 11.5px;\r\n  transition: border-color 150ms ease, background 150ms ease, color 150ms ease;\r\n}\r\n.montgt-session:hover { border-color: #3b82f6; }\r\n.montgt-session-warn { border-color: #fbbf24; color: #92400e; }\r\n\r\n.montgt-session-label {\r\n  flex: 1;\r\n  text-align: left;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.montgt-menu {\r\n  position: absolute;\r\n  top: calc(100% + 4px);\r\n  right: 0;\r\n  z-index: 20;\r\n  min-width: 260px;\r\n  max-height: 320px;\r\n  overflow: auto;\r\n  padding: 4px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);\r\n  animation: montgt-fade-swap 150ms ease-out;\r\n}\r\n@keyframes montgt-fade-swap {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.montgt-group-title {\r\n  padding: 5px 8px 3px;\r\n  font-size: 10.5px;\r\n  font-weight: 600;\r\n  color: #9ca3af;\r\n}\r\n\r\n.montgt-option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  width: 100%;\r\n  padding: 5px 8px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: none;\r\n  color: #374151;\r\n  font-size: 11.5px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background 150ms ease;\r\n}\r\n.montgt-option:hover:not(:disabled) { background: #f3f4f6; }\r\n/* 실행 중인 세션 — 눌러도 서버가 409 로 거절하므로 아예 막고, 왜 막혔는지 배지로 말한다 */\r\n.montgt-option:disabled { opacity: 0.5; cursor: not-allowed; }\r\n\r\n.montgt-opt-conn { color: #6b7280; flex-shrink: 0; }\r\n.montgt-opt-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n.montgt-opt-sid { color: #9ca3af; font-variant-numeric: tabular-nums; }\r\n.montgt-opt-busy {\r\n  padding: 0 6px;\r\n  border-radius: 999px;\r\n  background: #fef3c7;\r\n  color: #92400e;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n}\r\n\r\n.montgt-warn {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 5px;\r\n  padding: 6px 8px;\r\n  margin-bottom: 3px;\r\n  border-radius: 4px;\r\n  background: #fffbeb;\r\n  color: #92400e;\r\n  font-size: 10.5px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.montgt-empty { padding: 10px 8px; color: #9ca3af; text-align: center; }\r\n\r\n/* ===================== Dark mode ===================== */\r\n/* color 를 함께 주지 않으면 밝은 모드 값이 남아 어두운 배경에 검은 글자가 된다 */\r\n[data-theme=\"dark\"] .montgt-sep { color: var(--color-border); }\r\n[data-theme=\"dark\"] .montgt-conn,\r\n[data-theme=\"dark\"] .montgt-session {\r\n  background: var(--color-input-bg);\r\n  border-color: var(--color-input-border);\r\n  color: var(--color-text);\r\n}\r\n[data-theme=\"dark\"] .montgt-conn:hover { border-color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .montgt-session:hover { border-color: #3b82f6; color: var(--color-text); }\r\n[data-theme=\"dark\"] .montgt-session-warn { border-color: #b45309; color: #fcd34d; }\r\n[data-theme=\"dark\"] .montgt-menu {\r\n  background: var(--color-bg-tertiary);\r\n  border-color: var(--color-border);\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);\r\n}\r\n[data-theme=\"dark\"] .montgt-group-title { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .montgt-option { color: var(--color-text); }\r\n[data-theme=\"dark\"] .montgt-option:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }\r\n[data-theme=\"dark\"] .montgt-opt-conn { color: var(--color-text-secondary, #9ca3af); }\r\n[data-theme=\"dark\"] .montgt-opt-sid { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .montgt-opt-busy { background: #78350f; color: #fcd34d; }\r\n[data-theme=\"dark\"] .montgt-warn { background: rgba(180, 83, 9, 0.18); color: #fcd34d; }\r\n[data-theme=\"dark\"] .montgt-empty { color: var(--color-text-muted); }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .montgt-menu { animation: none; }\r\n  .montgt-conn, .montgt-session, .montgt-option { transition: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
